$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 800) {
        $(".back-to-top").addClass("is-visible");
    } else {
        $(".back-to-top").removeClass("is-visible");
    }

});
